/*

https://github.com/themesberg/flowbite-icons

Flowbite Icons is free and open-source under the MIT License.

*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function Pencil({
    className = null,
}: Props) {
    return (
        <svg className={className} width="12" height="13" viewBox="0 0 12 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.8523 1.20571C9.98934 0.264765 8.58456 0.264765 7.72156 1.20571L1.83789 7.62427C1.77903 7.68848 1.73998 7.76409 1.71303 7.8439C1.71138 7.8493 1.70643 7.8529 1.70478 7.8583L0.528264 11.7097C0.46226 11.9251 0.513963 12.1633 0.661371 12.3236C0.765877 12.4382 0.906685 12.5 1.05024 12.5C1.10855 12.5 1.1674 12.4898 1.22405 12.4688L4.7536 11.1846C4.75855 11.1828 4.76185 11.178 4.76625 11.1762C4.83995 11.1474 4.90926 11.1042 4.96811 11.04L10.8523 4.62202C11.7159 3.68048 11.7159 2.14725 10.8523 1.20571ZM6.93337 3.76209L7.33324 4.19836C7.33214 4.19956 7.33049 4.20016 7.32939 4.20136L3.40382 8.4836L3.00505 8.04853L6.93337 3.76209ZM1.91984 10.9512L2.46712 9.1593L3.56168 10.3535L1.91984 10.9512ZM4.57979 9.76719L4.18102 9.33213L8.10659 5.04988C8.10769 5.04868 8.10824 5.04688 8.10934 5.04568L8.50866 5.48135L4.57979 9.76719ZM10.0746 3.77349L9.28695 4.63282L7.71111 2.91356L8.49876 2.05423C8.93328 1.58016 9.64007 1.58076 10.074 2.05423C10.5091 2.5283 10.5091 3.29942 10.0746 3.77349Z" />
        </svg>
    );
}
